import React from 'react';
import { Button, Checkbox, Input } from 'antd';

const VendorForm = ({
    vendor,
    type,
    recurring,
    handleVendorChange,
    handleTypeChange,
    handleRecurringChange,
    handleSubmit,
    isUpdate
}) => {

    return (
        <div className="compact-form">
            <form onSubmit={handleSubmit}>
                <label className="form-field" htmlFor="vendor">
                    <span>Vendor Name</span>
                    <Input
                        type="text"
                        id="vendor"
                        value={vendor}
                        onChange={handleVendorChange}
                        required
                    />
                </label>
                <label className="form-field" htmlFor="type">
                    <span>Type</span>
                    <Input
                        type="text"
                        id="type"
                        value={type}
                        onChange={handleTypeChange}
                    />
                </label>
                <Checkbox
                    id="recurring"
                    checked={recurring}
                    onChange={handleRecurringChange}
                >
                    Recurring
                </Checkbox>
                <Button type="primary" htmlType="submit" block>
                    {isUpdate ? 'Update' : 'Create'}
                </Button>
            </form>
        </div>
    );
};

export default VendorForm;
